export const gameVersions = [
  'live',
  'classic_era',
  'classic_anniversary',
  'classic_progression',
] as const

export const gameVersionToSubdomain = {
  live: '',
  classic_era: 'vanilla.',
  classic_anniversary: 'anniversary.',
  classic_progression: 'classic.',
} as const

type GameVersion = typeof gameVersions[number]
export default GameVersion
